// import Axios from 'axios';
import { showErrorMessage } from '../../common/Toaster';
import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR
} from './../types/actions/Common.actions';
import jwtAxios from '../../services/axiosInstance/ApiConfig';
import { SET_ALL_PRODUCTS, SET_SELECTED_PRODUCT } from '../types/actions/ProductAction';
import { productsResponse } from '../../services/dbs/bazzarey_dbs';
// import {
//   PRODUCT_CREATE_FAIL,
//   PRODUCT_CREATE_REQUEST,
//   PRODUCT_CREATE_SUCCESS,
//   PRODUCT_DETAILS_FAIL,
//   PRODUCT_DETAILS_REQUEST,
//   PRODUCT_DETAILS_SUCCESS,
//   PRODUCT_LIST_FAIL,
//   PRODUCT_LIST_REQUEST,
//   PRODUCT_LIST_SUCCESS,
//   PRODUCT_UPDATE_REQUEST,
//   PRODUCT_UPDATE_SUCCESS,
//   PRODUCT_UPDATE_FAIL,
//   PRODUCT_DELETE_REQUEST,
//   PRODUCT_DELETE_FAIL,
//   PRODUCT_DELETE_SUCCESS,
//   PRODUCT_CATEGORY_LIST_SUCCESS,
//   PRODUCT_CATEGORY_LIST_REQUEST,
//   PRODUCT_CATEGORY_LIST_FAIL,
//   PRODUCT_REVIEW_CREATE_REQUEST,
//   PRODUCT_REVIEW_CREATE_SUCCESS,
//   PRODUCT_REVIEW_CREATE_FAIL,
// } from './../../constants/productConstants';


export const onGetAllProducts = ({
  pageNumber = '',
  seller = '',
  name = '',
  category = '',
  subcategory = '',
  order = '',
  min = 0,
  max = 0,
  rating = 0,
}: any) => async (dispatch: any) => {
  try {
    dispatch({ type: FETCH_START })
    const { data } = await jwtAxios.get(
      `/products?pageNumber=${pageNumber}&seller=${seller}&name=${name}&category=${category}&subcategory=${subcategory}&min=${min}&max=${max}&rating=${rating}&order=${order}`
    );
    dispatch({ type: FETCH_SUCCESS })
    dispatch({ type: SET_ALL_PRODUCTS, payload: data });
  } catch (error: any) {
    if(error.code === "ERR_NETWORK") {
      dispatch({ type: FETCH_SUCCESS })
      dispatch({ type: SET_ALL_PRODUCTS, payload: productsResponse });
    } else {
      dispatch({ type: FETCH_ERROR, error })
      showErrorMessage(error)
    }
  }
};

// export const listProductCategories = () => async (dispatch) => {
//   dispatch({
//     type: PRODUCT_CATEGORY_LIST_REQUEST,
//   });
//   try {
//     const { data } = await Axios.get(`/api/products/categories`);
//     dispatch({ type: PRODUCT_CATEGORY_LIST_SUCCESS, payload: data });
//   } catch (error) {
//     dispatch({ type: PRODUCT_CATEGORY_LIST_FAIL, payload: error.message });
//   }
// };

export const detailsProduct = (productId: string) => async (dispatch: any) => {
  try {
    dispatch({ type: FETCH_START })
    const { data } = await jwtAxios.get(`/products/${productId}`);
    dispatch({ type: FETCH_SUCCESS })
    dispatch({ type: SET_SELECTED_PRODUCT, payload: data });
  } catch (error: any) {
    dispatch({ type: FETCH_ERROR, error })
    showErrorMessage(error)
  }
};
// export const createProduct = () => async (dispatch, getState) => {
//   dispatch({ type: PRODUCT_CREATE_REQUEST });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.post(
//       '/api/products',
//       {},
//       {
//         headers: { Authorization: `Bearer ${userInfo.token}` },
//       }
//     );
//     dispatch({
//       type: PRODUCT_CREATE_SUCCESS,
//       payload: data.product,
//     });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.message
//         ? error.response.data.message
//         : error.message;
//     dispatch({ type: PRODUCT_CREATE_FAIL, payload: message });
//   }
// };
// export const updateProduct = (product) => async (dispatch, getState) => {
//   dispatch({ type: PRODUCT_UPDATE_REQUEST, payload: product });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.put(`/api/products/${product._id}`, product, {
//       headers: { Authorization: `Bearer ${userInfo.token}` },
//     });
//     dispatch({ type: PRODUCT_UPDATE_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.message
//         ? error.response.data.message
//         : error.message;
//     dispatch({ type: PRODUCT_UPDATE_FAIL, error: message });
//   }
// };
// export const deleteProduct = (productId) => async (dispatch, getState) => {
//   dispatch({ type: PRODUCT_DELETE_REQUEST, payload: productId });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     Axios.delete(`/api/products/${productId}`, {
//       headers: { Authorization: `Bearer ${userInfo.token}` },
//     });
//     dispatch({ type: PRODUCT_DELETE_SUCCESS });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.message
//         ? error.response.data.message
//         : error.message;
//     dispatch({ type: PRODUCT_DELETE_FAIL, payload: message });
//   }
// };
// export const createReview = (productId, review) => async (
//   dispatch,
//   getState
// ) => {
//   dispatch({ type: PRODUCT_REVIEW_CREATE_REQUEST });
//   const {
//     userSignin: { userInfo },
//   } = getState();
//   try {
//     const { data } = await Axios.post(
//       `/api/products/${productId}/reviews`,
//       review,
//       {
//         headers: { Authorization: `Bearer ${userInfo.token}` },
//       }
//     );
//     dispatch({
//       type: PRODUCT_REVIEW_CREATE_SUCCESS,
//       payload: data.review,
//     });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.message
//         ? error.response.data.message
//         : error.message;
//     dispatch({ type: PRODUCT_REVIEW_CREATE_FAIL, payload: message });
//   }
// };
